import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

import Card from '@intec/vue-components/form/Card.vue';

interface Props {
  cancellationReasons: Array<{id: Number, explanation: string}>,
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CancellationReasonsView',
  props: {
    cancellationReasons: { default: [] }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!

  return (_openBlock(), _createBlock(Card, { class: "mb-2" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "cardTitle pa-0" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('Причины отсутствия победителя')), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.cancellationReasons, (reason) => {
        return (_openBlock(), _createBlock(_component_v_card_text, {
          key: reason.id,
          class: "pa-0"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(reason.explanation), 1 /* TEXT */)
          ]),
          _: 2 /* DYNAMIC */
        }, 1024 /* DYNAMIC_SLOTS */))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _: 1 /* STABLE */
  }))
}
}

})